<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="menuBox">
			<div class="menuItem">序号</div>
			<div class="menuItem">发票类型</div>
			<div class="menuItem">开票金额</div>
			<div class="menuItem">状态</div>
			<div class="menuItem">订单操作</div>
		</div>
		<div class="invoiceList" v-if="invoiceData.length">
			<div class="invoiceItem" v-for="(item,index) in invoiceData" :key="index">
				<div class="no">{{index + 1}}</div>
				<div class="type">{{item.lx_type == 1 ? '个人': '企业'}}发票</div>
				<div class="cost"><span class="unit">¥</span>{{item.price}}</div>
				<div class="status">{{item.status == 1 ? '已处理' : '未处理'}}</div>
				<div class="detail">
					<div class="look" @click="lookInvoiceDetails(item)">查看详情</div>
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<PagePagination style="padding: .32rem 0 .16rem;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
	</div>
</template>

<script>
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'MyInvoice',
		components: {
			PagePagination,
		},
		data() {
			return {
				invoiceData: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				// 分类导航
				categories: [{
						key: '',
						name: '全部'
					},
					{
						key: '2',
						name: '待处理'
					},
					{
						key: '1',
						name: '已处理'
					}
				],
				activeCategory: '',
			}
		},
		mounted() {
			this.invoiceList()
		},
		methods: {
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.invoiceList()
			},
			onPageChange(newPage) {
				this.currentPage = newPage
				this.invoiceList()
			},
			invoiceList() {
				this.$api.post('UserD/invoice_list', {
					p: this.currentPage,
					status: this.activeCategory,
				}).then(res => {
					if (res.code == 1) {
						this.invoiceData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			lookInvoiceDetails(item) {
				this.$emit('lookDetails', item)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.menuBox {
		display: flex;
		align-items: center;

		.menuItem:nth-child(1) {
			width: 1rem;
		}

		.menuItem:nth-child(2) {
			width: 3rem;
		}

		.menuItem:nth-child(3) {
			width: 2rem;
		}

		.menuItem:nth-child(4) {
			width: 2rem;
		}

		.menuItem:nth-child(5) {
			width: 1.55rem;
		}

		.menuItem {
			height: .5rem;
			font-weight: 400;
			font-size: .14rem;
			color: #666666;
			text-align: center;
			line-height: .5rem;
		}
	}

	.invoiceList {
		display: flex;
		flex-direction: column;

		.invoiceItem {
			display: flex;
			align-items: center;
			height: .6rem;
			border-bottom: .01rem solid #CCCCCC;

			.no {
				height: .6rem;
				width: 1rem;
				font-weight: 400;
				font-size: .16rem;
				color: #040404;
				line-height: .6rem;
				text-align: center;
			}

			.type {
				height: .6rem;
				width: 3rem;
				font-weight: 400;
				font-size: .16rem;
				color: #040404;
				line-height: .6rem;
				text-align: center;
			}

			.cost {
				height: .6rem;
				width: 2rem;
				font-weight: 700;
				font-size: .16rem;
				color: #000000;
				line-height: .6rem;
				text-align: center;

				.unit {
					font-weight: 400;
				}
			}

			.status {
				height: .6rem;
				width: 2rem;
				font-weight: 400;
				font-size: .16rem;
				color: #E29358;
				line-height: .6rem;
				text-align: center;
			}

			.detail {
				height: .6rem;
				width: 1.55rem;
				display: flex;
				align-items: center;
				justify-content: center;

				.look {
					width: .76rem;
					height: .3rem;
					background: #E29358;
					border-radius: .04rem;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
					line-height: .3rem;
					text-align: center;
					cursor: pointer;
				}
			}
		}
	}
</style>